import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

function InteriorDesign() {
  return (
    <>
      <Container
        fluid
        style={{
          minHeight: "80vh",
        }}
        className="App"
      >
        <Row>
          <Col className="App-interior-page-bg"></Col>
        </Row>
        <Row className="App-section App-bg-color-light">
          <Col className="App-section-col">
            <h1
              className="tinos-regular"
              style={{
                paddingBottom: "20px",
              }}
            >
              interior design
            </h1>
            <div className="quattrocento-sans-bold">
              Our highly skilled and creative Interior Designers will work
              closely with you to create and realise wonderful spaces.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Our experience stretches across a diverse range of design domains,
              residential, office and hospitality. We create tailored and
              detailed visions encompassing the needs of our clients and their
              aspirations. We have a passion for detail and are committed to
              creating resolved, layered and deeply detailed, opulent spaces.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Throughout the design process, we centre our client's requirements
              as an anchor for our creation. We derive inspiration from many
              influences, layering many styles to create unique aesthetics.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We have in-depth experience in high-end residential interior
              design, working for both private individuals and some of the
              country&apos;s biggest property developers.
            </div>
            <br />
            <Button
              style={{
                marginBottom: "20px",
                fontFamily: "Quattrocento Sans, sans-serif",
                fontWeight: "700",
              }}
              href="mailto:HelloUrbanGroup@gmail.com"
              variant="light"
            >
              contact us
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default InteriorDesign;
